export const Messages = {
  loadingMessage: 'Cognitive Assessment is loading. Please wait ...',
  responseSavingMessage: 'Your answers are being saved. Please wait ...',
};
